// this component is used only in Executive and CEO dashboard

import React, { useState, useEffect } from "react";

import styles from "./index.module.scss";

import { Metric, MetricsWrapper } from "../Metric";
import BarChart from "../BarChart";
import * as icons from "../../config/Icons";
import { useTranslation } from "react-i18next";

function SessionClosed({ data, country, labels, maxHeight = "auto" }) {
  const { t } = useTranslation();
  const [maxValue, setMaxValue] = useState(0);
  const numberFormat = new Intl.NumberFormat();

  useEffect(() => {
    if (data && data.campaignData) {
      const filteredMaxValue = Math.max.apply(
        Math,
        data.campaignData.map(function (o) {
          return o.average_sessions_closed;
        })
      );
      setMaxValue(filteredMaxValue);
    }
  }, [data]);

  return (
    <div className={`${styles.row} ${styles.noBorder} ${styles.w100}`}>
      <h4
        className={`${styles.sectionHead} ${styles.alignLeft} ${styles.bold}`}
      >
        {t("dashboard.executive.sessionClosed")} <br />{" "}
        <span className={styles.info}> {t("dashboard.executive.overall")}</span>
      </h4>
      {data && data.campaignData ? (
        <>
          {" "}
          <MetricsWrapper dashboard={true}>
            <Metric
              fullWidth
              color="#8FDEB2"
              label={t("dashboard.executive.totalInprogress")}
              data={
                data.overall.total_sessions_inprogress
                  ? numberFormat.format(data.overall.total_sessions_inprogress)
                  : "0"
              }
            />
            <Metric
              fullWidth
              color="#8FDEB2"
              label={t("dashboard.executive.totalSessionClosed")}
              data={
                data.overall.total_sessions_closed
                  ? numberFormat.format(data.overall.total_sessions_closed)
                  : "0"
              }
            />
            <Metric
              fullWidth
              color="#8FDEB2"
              label={t("dashboard.executive.totalCoachees")}
              data={
                data.overall.total_coachees
                  ? numberFormat.format(data.overall.total_coachees)
                  : "0"
              }
            />
            <span className={styles.divider}></span>
            <Metric
              fullWidth
              color="#13C77A"
              label={t("dashboard.executive.avgSessionClosed")}
              data={
                data.overall.average_sessions_closed
                  ? numberFormat.format(data.overall.average_sessions_closed)
                  : "0"
              }
            />
            <Metric
              fullWidth
              color="#006929"
              label={t("dashboard.executive.avgUsageRate")}
              data={
                data.overall.total_sessions_utlization
                  ? data.overall.total_sessions_utlization + "%"
                  : "0%"
              }
            />
          </MetricsWrapper>
          <div className={`${styles.sectionRow} ${styles.sectionRowHead}`}>
            <div className={styles.w20}>{labels[0]}</div>
            <div className={`${styles.w20} ${styles.alignCenter}`}>
              {labels[1]}
            </div>
            <div className={`${styles.w20} ${styles.alignCenter}`}>
              {labels[2]}
            </div>
            <div className={`${styles.w20} ${styles.alignCenter}`}>
              {labels[3]}
            </div>
            <div className={styles.w30}>{labels[4]}</div>
            <div className={styles.w30}>{labels[5]}</div>
          </div>
          <div className={styles.scrollBlock} style={{ maxHeight: maxHeight }}>
            {data.campaignData &&
              data.campaignData.map((list, index) => {
                const flagIcon = list.label + "FlagIcon";
                return (
                  <div className={styles.sectionRow} key={index}>
                    <div className={styles.w20}>
                      {country && (
                        <img src={icons[flagIcon]} alt={list.label} />
                      )}
                      {list.label}
                    </div>
                    <div className={`${styles.w20} ${styles.alignCenter}`}>
                      {numberFormat.format(list.total_sessions_inprogress)}
                    </div>
                    <div className={`${styles.w20} ${styles.alignCenter}`}>
                      {numberFormat.format(list.total_sessions_closed)}
                    </div>

                    <div className={`${styles.w20} ${styles.alignCenter}`}>
                      {numberFormat.format(list.total_coachees)}
                    </div>

                    <div className={styles.w30}>
                      <BarChart
                        colors={["#13C77A"]}
                        fontColors={["#212121"]}
                        maxValue={maxValue}
                        showLabel={false}
                        data={[
                          {
                            name: list.label,
                            primary: list.average_sessions_closed
                              ? list.average_sessions_closed
                              : "0",
                          },
                        ]}
                      />
                    </div>
                    <div className={styles.w30}>
                      <BarChart
                        colors={["#13C77A"]}
                        fontColors={["#212121"]}
                        maxValue={maxValue}
                        showLabel={false}
                        data={[
                          {
                            name: list.label,
                            primary: list.total_sessions_utlization
                              ? list.total_sessions_utlization + "%"
                              : "0%",
                          },
                        ]}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      ) : (
        <div className={styles.noData}>No Data</div>
      )}
    </div>
  );
}

export default SessionClosed;
